<template>
  <div class="box">
    <div class="box-header">
      <h3 class="box-title" :style="titleCustomStyle">
        {{ title }}
      </h3>
      <div v-if="rewards" class="add-on">
        {{ $tc(
          'bounties.rewardsOverviewCounter',
          rewards.length,
          { number: rewards.length }
        ) }}
      </div>
    </div>
    <div v-if="filters.length > 0" class="filters-section">
      <template v-for="(filter, index) in filters">
        <bounty-multi-select-filter
          v-if="filter.type === 'multi-select'"
          :key="index"
          :filterData="filter"
          :custom-style="filtersCustomStyle"
          @registered-filter="registerFilter"
          @applied-filter="applyFilter"
        />
      </template>
    </div>
    <div class="box-body">
      <bounties-overview-container>
        <div class="loading" v-if="loading">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <bounty
          :key="reward.id"
          v-for="reward in rewards"
          :bounty="reward"
          :compact="true"
          :display-icon="false"
          :custom-style="bountyCustomStyle"
        />
        <div v-if="rewards && rewards.length == 1" class="blank-item"></div>
      </bounties-overview-container>
    </div>
  </div>
</template>

<script>
import {
  mdiWalletGiftcard,
  mdiTicket,
  mdiCheckCircle,
  mdiCartPlus
} from '@mdi/js'
import Bounty from './Bounty'
import BountiesOverviewContainer from './BountiesOverviewContainer'
import groupedRewards from '@/mixins/groupedRewards'
import BountyMultiSelectFilter from './filters/BountyMultiSelectFilter'

export default {
  name: "RewardsOverview",
  components: {
    Bounty,
    BountiesOverviewContainer,
    BountyMultiSelectFilter
  },
  mixins: [groupedRewards],
  data() {
    return {
      defaultTitle: this.$t('bounties.rewardsOverviewTitle'),
      defaultGroup: 'rewards-overview',
      icons: {
        mdiWalletGiftcard,
        mdiTicket,
        mdiCheckCircle, mdiCartPlus
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(255,255,255,.8);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filters-section {
  margin-bottom: 14px;
}
</style>
